<template>
  <div class="staging-select">
    <!--<button class="btn btn-primary version-goto" @click="navigateToStagingDashboard">Inventory version (Béta)</button>-->
    <span>Select inventory version:</span>
    <select v-model="selected" class="version-select">
      <option :value="undefined">{{$t('inventory_staging.no_selected')}}</option>
      <option v-for="v of versions" :value="v">{{v.name}}</option>
    </select>
  </div>
</template>

<script>
import {Core} from "@/core/Core";

export default {
  name: "StagingSelect",

  props: {
    inventory: Number
  },

  data() {
    return {
      selected: undefined,
      versions: []
    }
  },

  watch: {
    inventory: {
      immediate: true,
      async handler() {
        this.selected = undefined;
        await this.reloadUpcomingVersions();
      }
    },
    selected(version) {
      this.$store.commit("setContextVersion", version);
    }
  },

  methods: {
    async reloadUpcomingVersions() {
      this.versions = await Core.noThrowRequest('GET', `/api/inventory/${this.inventory}/versions_in_draft`) || [];
    },
    navigateToStagingDashboard() {
      this.$router.push(this.$router.buildContext("/staging")).catch(()=>{});
    }
  }
}
</script>

<style lang="scss" scoped>
.version-select {
  margin-right: 10px;
  font-size: 14px;
  padding: 4px 10px;
}
.version-goto {
  margin-right: 5px;
}
</style>